export const getFullOrShortList = <T>(arr: T[], showAllList = false, shortQty = 2): T[] => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return [];
  }

  return showAllList ? arr : arr.slice(0, shortQty);
};
